import { PaginatedColumn } from "../types/app";
import { TenantRequest, TenantRequestTouched } from "../types/tenants";

export const TENANTS_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: "Nombre",
    key: "name",
  },
  {
    label: "Razón social",
    key: "socialReason",
    flex: 1,
  },
  {
    label: "Activo",
    key: "active",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    label: "Actions",
    key: "actions",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
];

export const TENANT_DEFAULTS: TenantRequest = {
  name: "",
};

export const TENANT_TOUCHED_DEFAULTS: TenantRequestTouched = {
  nameTouched: false,
};
